import * as React from 'react';

const Chat = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={18} height={18} fill="none" viewBox="0 0 18 18" {...props}>
        <path
            fill="#002395"
            d="M5.667 8.166a.833.833 0 1 0 0 1.667.833.833 0 0 0 0-1.667m3.333 0a.833.833 0 1 0 0 1.667.833.833 0 0 0 0-1.667m3.333 0a.833.833 0 1 0 0 1.666.833.833 0 0 0 0-1.666M9 .666A8.333 8.333 0 0 0 .667 8.999a8.24 8.24 0 0 0 1.883 5.275L.883 15.941a.83.83 0 0 0-.175.908.83.83 0 0 0 .792.484H9A8.334 8.334 0 0 0 9 .666m0 15H3.508l.775-.775a.83.83 0 0 0 .25-.592.83.83 0 0 0-.25-.583A6.667 6.667 0 1 1 9 15.666"
        />
    </svg>
);
export default Chat;
